<template>
  <div class="app-container withdraw">
    <div class="header" style="display:flex;justify-content:flex-end;align-items:center;width:100%;">
      
      <el-input
        v-model="listQuery.name_phone"
        placeholder="手机号或名称"
        :clearable="true"
        style="width: 220px;margin: 0px 10px;margin-left: 20px;"
      ></el-input>

      <el-input
        v-model="listQuery.text"
        placeholder="绘画描述"
        :clearable="true"
        style="width: 220px;margin: 0px 10px;margin-left: 20px;"
      ></el-input>

      <el-button
        size="small"
        type="primary"
        style="margin-left: 15px;"
        @click="search"
        >搜索</el-button
      >
    </div>
    <!-- <div class="fenxiao">￥分销总金额: {{ rewardMoney }}</div>
    <div class="fenxiao">￥提现总金额: {{ cashoutMoney }}</div>
    <div class="fenxiao">￥未处理金额: {{ cashoutUnAdoptMoney }}</div>
    <div class="fenxiao">￥已处理金额: {{ cashoutAdoptMoney }}</div> -->

    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="ID" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>

      <el-table-column label="头像" min-width="60" align="center">
        <template slot-scope="scope">
           <el-avatar :src="scope.row.user?scope.row.user.avatar:'-'"></el-avatar>
        </template>
      </el-table-column>
      
      <el-table-column label="昵称" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.user?scope.row.user.nickname:"-"
        }}</template>
      </el-table-column>

      <el-table-column label="联系电话" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.user?scope.row.user.phone: "-"
        }}</template>
      </el-table-column>

     <el-table-column label="绘画描述" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.prompt_cn
        }}</template>
      </el-table-column>

      <el-table-column label="绘画风格" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.style
        }}</template>
      </el-table-column>
<!-- 
      <el-table-column label="尺寸" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.resolution
        }}</template>
      </el-table-column> -->

       <el-table-column label="绘画风格" align="center" min-width="110">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'fail'" type="warning">失败</el-tag>    
          <el-tag v-else-if="scope.row.status === 'upscale' " type="success">成功</el-tag>
          <el-tag v-else type="primary">绘画中</el-tag>  
        </template>
      </el-table-column>  

      <el-table-column label="图片" align="center" min-width="180">
        <template slot-scope="scope">
          <el-image 
          style="width: 80%; height: 80%"
          :src="scope.row.img_urls?scope.row.img_urls[0]:'-'"
          :preview-src-list="scope.row.img_urls">
        </el-image>
        <div>共 {{  scope.row.img_urls?scope.row.img_urls.length :'0'}} 张图片</div>
        </template>
      </el-table-column>
    
      <el-table-column label="创建时间" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.created_at || "-"
        }}</template>
      </el-table-column>
     
      <!-- <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="handlePass(scope.row,1)"
            v-if="scope.row.state == 0"
            >通过</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="handlePass(scope.row,2)"
            v-if="scope.row.state == 0"
            >驳回</el-button
          >
          <!-- <el-button size="small" type="success" @click="handleWatch(scope.row)" v-if="scope.row.status != 1">查看</el-button> -->
        <!-- </template>
      </el-table-column> --> -->
    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 10,
        start_date: "",
        end_date: "",
        order_on: "",
        type: "",
      },
      start_date: "",
      end_date: "",
      dialogVisible: false,
      list: [],
      rewardMoney: 0,
      cashoutMoney: 0,
      cashoutUnAdoptMoney: 0,
      cashoutAdoptMoney: 0
    };
  },
  mounted() {
    this.getList();
    // console.log(this.$store.state.user.username)
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.start_date = this.start_date
        ? this.start_date + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_date
        ? this.end_date + " 23:59:59"
        : "";
      request({
        url: "/api/backend/creativeSpace/index",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    pass(row,type) {
      request({
        url: "/api/backend/wallet/update",
        method: "post",
        data: { id: row.id,
                type: type
        }
      })
        .then(() => {
          this.$notify.success("操作成功");
          this.getList();
        })
        .catch(() => {
          this.$notify.error("操作失败");
        });
    },
    handlePass(row,type) {
      this.$confirm(
        `确认${type==1?'通过':'驳回'} ${row.user.nickname} 的提现 ￥${row.amount} 申请?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
        ) 
        .then(() => {
          this.pass(row,type);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleWatch(row) {
      this.$router.push("/finance/cashout?id=" + row.id + "&type=watch");
    },
    search() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    }
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
</style>